import styled from "styled-components";

const Header = () => {
  return <SHeader>광고관리</SHeader>;
};

const SHeader = styled.header`
  /* margin-bottom: 10px; */
  height: 50px;
`;
export default Header;
